import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant';
//
export const selection = data => {
  return axios.post(Urls.selectUrl, {
    page: data.pageIndex,
    page_size: data.pageSize,
    orders: {
      created_at: {
        desc: true,
        enable: true
      }
    }
  });
};
//
export const useSelect = ({
  params,
  config
}) => {
  return useQuery([ListQueryKey, params], () => selection(params), config);
};